import { useContext, useEffect, useState } from "react";
import "../../../../../styles/workspace_styles/TenantAdministratorStyles/Invoices/Invoice/Invoice.css";
import { InvoiceContext } from "../InvoiceProvider";
import { billingMicroserviceUrl } from "../../../../../microservices/billing_microservice";
import { AppContext } from "../../../../AppProvider";
import InvoicePreview from "./InvoicePreview";
import InvoiceDetails from "./InvoiceDetails";
const Invoice = () =>{
    const {user,logout} = useContext(AppContext);
    const {
        selectedInvoiceSummary,setSelectedInvoiceSummary,
        selectedInvoice,setSelectedInvoice,
    } = useContext(InvoiceContext);
    const [selectedInvoiceTab,setSelectedInvoiceTab] = useState('default');
    const fetchSelectedInvoice =  async() =>{
        try{
            if(!selectedInvoiceSummary) return;
            const url = `${billingMicroserviceUrl}/tenants/invoices/${selectedInvoiceSummary?.id}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok){
                const responseData = await response.json();
                console.log('Invoice',responseData);
                setSelectedInvoice(responseData);
            }
            else if(response.status === 401) logout();
            else if(response.status === 500) throw new Error(`response code: ${response.status}`);
        }
        catch(error){
            console.error(`An error occurred when fetching invoice with ID: ${selectedInvoiceSummary?.id}`,error);
        }
    };
    const disposeWindow = () =>{
        setSelectedInvoiceSummary(null);
        setSelectedInvoice(null);
    };
    useEffect(() =>{
        if(selectedInvoiceSummary && selectedInvoice !== null) setSelectedInvoice(null);
        else if(selectedInvoiceSummary) fetchSelectedInvoice();
    },[selectedInvoiceSummary]);
    useEffect(() =>{
        if(selectedInvoiceSummary && selectedInvoice === null) fetchSelectedInvoice();
    },[selectedInvoice]);
    if(!selectedInvoiceSummary) return null;
    return(
        <div className="tenant-administrator-invoice-container">
            <div className="tenant-administrator-invoice-container-header">
                <div>
                    <h3>{selectedInvoice?.customerName || 'Loading...'}</h3>
                    <h4>Invoice</h4>
                </div>
                <div>
                    <p onClick={() => disposeWindow()}>&#10006;</p>
                </div>
            </div>
            <div className="tenant-administrator-invoice-navigation-bar">
                <button
                    className={selectedInvoiceTab === 'default' || selectedInvoiceTab === 'details'? 'active':''}
                    onClick={() => setSelectedInvoiceTab('details')}>Invoice details
                </button>
                <button
                    className={selectedInvoiceTab === 'preview'? 'active':''}
                    onClick={() => setSelectedInvoiceTab('preview')}>Preview invoice
                </button>
            </div>
            <div className="tenant-administrator-invoice-container-body">
                {selectedInvoice?
                    (
                        <div>
                            <InvoiceDetails selectedInvoiceTab={selectedInvoiceTab}/>
                            <InvoicePreview selectedInvoiceTab={selectedInvoiceTab}/>
                        </div>
                    ):(
                        <div className="tenant-administrator-loading-selected-invoice-container">
                            <div>
                            </div>
                            <p>Loading invoice...</p>
                        </div>
                    )
                }
            </div>
        </div>
    );
};
export default Invoice;